var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinCompost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6206,
    cy: 14,
    r: 13.5,
    fill: "#784949",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0629 6.38455C20.8653 6.1874 20.6265 6.03654 20.3636 5.94285C20.1007 5.84915 19.8203 5.81494 19.5426 5.8427C17.777 6.01341 11.8393 6.74874 9.54588 9.0401C8.44959 10.1396 7.79951 11.6064 7.72118 13.1572C7.64284 14.7081 8.1418 16.2329 9.12171 17.4373L6.63106 19.9285C6.51591 20.0477 6.4522 20.2074 6.45364 20.3732C6.45508 20.539 6.52156 20.6976 6.63876 20.8148C6.75597 20.932 6.91452 20.9985 7.08026 21C7.24601 21.0014 7.40569 20.9377 7.52491 20.8225L10.0156 18.3314C11.2195 19.3128 12.7444 19.8129 14.2956 19.735C15.8468 19.6571 17.314 19.0067 18.4136 17.9096C20.7373 15.5848 21.4479 9.66416 21.6116 7.90517C21.6384 7.62689 21.603 7.34614 21.5081 7.08317C21.4133 6.82021 21.2612 6.5816 21.0629 6.38455ZM17.5229 17.0131C16.661 17.872 15.516 18.3879 14.3017 18.4643C13.0874 18.5407 11.8867 18.1726 10.924 17.4285L17.0128 11.3384C17.1279 11.2192 17.1916 11.0595 17.1902 10.8937C17.1887 10.7279 17.1223 10.5693 17.0051 10.4521C16.8879 10.3349 16.7293 10.2684 16.5636 10.2669C16.3978 10.2655 16.2381 10.3292 16.1189 10.4444L10.0269 16.5344C9.28289 15.5715 8.9147 14.3706 8.99113 13.156C9.06756 11.9414 9.58337 10.7962 10.4423 9.93414C12.0283 8.3484 16.4015 7.4139 19.6646 7.10092C19.757 7.09192 19.8503 7.1034 19.9378 7.13454C20.0253 7.16568 20.1048 7.21572 20.1708 7.28109C20.2367 7.34646 20.2875 7.42556 20.3194 7.51277C20.3513 7.59998 20.3637 7.69315 20.3555 7.78567C20.0395 11.1917 19.1285 15.4039 17.5197 17.0131H17.5229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinCompost);
export default __webpack_public_path__ + "static/media/trash-bin-compost.54c1167646661f9e0a6041ec4a2ec533.svg";
export { ForwardRef as ReactComponent };